import { connect } from 'react-redux';

import PageContent from 'components/landing/PageContent';
import { parseAndCleanHtmlToReact } from 'helpers/HtmlHelpers';

const TPL_MATCH_DOUBLE_CURLY_BRACKETS = /\{\{\s*([^}^\s]*)\s*\}\}/g;

// 'fitsurvey'
const FS_ENCLOSING_HTML_P_TAG_RE = /^<p>([\s\S]*)<\/p>\n*$/;
const FS_MATCH_FIRST_LINE_RE = /^([^\n]*)\n/;
const FS_MATCH_ALL_NEWLINES_RE = /\n/g;

const templateTypeHandlerList = {
  'fitsurvey': (body, templateType, context = {}) => {
    const { [templateType]: tplValues = {} } = context;
    const finalBody = body
      .replace(FS_ENCLOSING_HTML_P_TAG_RE, '$1') // Remove enclosing HTML paragraph tags, if any.
      .replace(FS_MATCH_FIRST_LINE_RE, '<h2>$1</h2>\n') // Convert first line of paragraph into a heading.
      .replace(FS_MATCH_ALL_NEWLINES_RE, '<br />\n'); // Insert line break tags at, well, line breaks.
    return templateReplace(finalBody, tplValues);
  }
};

function templateReplace(body, values = {}) {
  return body.replace(TPL_MATCH_DOUBLE_CURLY_BRACKETS, (a,b) => values[b] || '');
}

function makePageSlotDetails(slotDetails, dynamicPageContent) {
  return { ...slotDetails, pageContent: dynamicPageContent, dynamicPageContent: undefined };
}

export const DynamicPageContent = ({ slotDetails, slotName, dynamicPageContentValues = {}, templateTypeHandlers = templateTypeHandlerList }) => {
  const { dynamicValues } = dynamicPageContentValues;
  const { dynamicPageContent, dynamicPageContent: { body, templatetype: templateType } } = slotDetails;

  const parsedBody = parseAndCleanHtmlToReact(
    templateTypeHandlers[templateType] ? templateTypeHandlers[templateType](body, templateType, dynamicValues) : body
  );

  return (
    <PageContent
      slotDetails={makePageSlotDetails(slotDetails, dynamicPageContent)}
      slotName={slotName}
      parsedBody={parsedBody} />
  );
};

const mapStateToProps = state => ({
  dynamicPageContentValues: state.dynamicPageContentValues
});

export default connect(mapStateToProps, {})(DynamicPageContent);
